import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from './authContext';
import Spinner from "./spinner";
import { useI18n } from "./utils/i18n";

function PrivateRoute({ children }) {
  const { isAuthenticated, authLoading, authConnectionError, refreshAuth } = useAuth()
  const { t } = useI18n();
  if (authLoading) {
    return <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', textAlign: 'center'}}><Spinner/></div>;
  }
  if (authConnectionError) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem', background: '#01040b', color: '#e2e8f0' }}>
        <div style={{ maxWidth: '32rem', width: '100%', border: '1px solid rgba(148,163,184,0.28)', borderRadius: '1rem', padding: '1.5rem', background: 'rgba(15,23,42,0.92)', boxShadow: '0 24px 60px rgba(15,23,42,0.35)' }}>
          <div style={{ fontSize: '1.1rem', fontWeight: 700, marginBottom: '0.75rem' }}>{t("auth.connection.local_https_title")}</div>
          <div style={{ fontSize: '0.95rem', lineHeight: 1.7, color: '#cbd5e1', marginBottom: '1rem' }}>{authConnectionError}</div>
          <button
            type="button"
            onClick={() => refreshAuth()}
            style={{ border: 'none', borderRadius: '0.75rem', padding: '0.75rem 1rem', fontWeight: 700, background: 'linear-gradient(90deg, #38bdf8, #818cf8)', color: '#020617', cursor: 'pointer' }}
          >
            {t("auth.connection.retry")}
          </button>
        </div>
      </div>
    );
  }
  return isAuthenticated ? children : <Navigate replace to="/"/>;
}

export default PrivateRoute;
